import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { useLang } from '../lib/i18n/LanguageContext';
import { dictionary } from '../lib/i18n/dictionary';
export function NotFoundPage() {
  const {
    lang
  } = useLang();
  const t = dictionary.notFound;
  return <main className="pt-32 pb-24 min-h-screen bg-white flex items-center justify-center" data-id="element-779">
      <div className="text-center max-w-md px-5" data-id="element-780">
        <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-gold-deep mb-4" data-id="element-781">
          404
        </p>
        <h1 className="font-serif text-4xl text-navy-deep mb-4" data-id="element-782">
          {t.title[lang]}
        </h1>
        <p className="text-slate-600 mb-8" data-id="element-783">{t.body[lang]}</p>
        <Link to="/" data-id="element-784">
          <Button variant="gold" size="lg" data-id="element-785">
            {t.home[lang]}
          </Button>
        </Link>
      </div>
    </main>;
}